import { TranslatedText } from "@/components/common/text";

export const Subtitle = ({ children }) => {
  return (
    <h3 className="text-base/[25px] text-cm-p-text-primary mb-2 font-semibold">
      <TranslatedText>{children}</TranslatedText>
    </h3>
  );
};
